import { User } from 'src/app/core/model/user-model';
import { TextHelper } from './../../../utils/text-helper';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-edit-phonenumber',
  templateUrl: './edit-phonenumber.component.html',
  styleUrls: ['./edit-phonenumber.component.scss'],
})
export class EditPhonenumberComponent implements OnInit {
  @Input() phonenumber: string;
  @Input() user: User;

  hasError = false;
  constructor(private textHelper: TextHelper) {}

  ngOnInit() {
    if (this.user.email) {
    } else {
      this.phonenumber = this.textHelper.replacePersian(this.phonenumber);
      if (this.phonenumber.length != 11) {
        this.hasError = true;
      }
    }
  }
}
